<template>
    <v-form ref="form">
      <v-layout row wrap class="progress-container">
        <!--task-->
        <v-flex xs10 md10>
          <v-tooltip :disabled="!showTooltip" top>
            <v-text-field
              v-model="record.task"
              slot="activator"
              label="Task"
              placeholder="Enter Task Description"
              :maxlength="300"
              counter
              required
              @blur="handleTextTrimmingRequired('task', record)"
              :error-messages="taskErrors">
            </v-text-field>
            <span>Enter Task Description</span>
          </v-tooltip>
        </v-flex>
        <!--delete button-->
        <v-flex xs12 md1>
          <v-layout row wrap justify-end>
            <v-tooltip :disabled="!showTooltip" top>
              <v-icon
                slot="activator"
                id="deleteIcon"
                @click="emitRemoveRecordClicked(index)"
                style="padding-top: 20px; padding-bottom: 10px;">
                mdi-delete
              </v-icon>
              <span>Delete Assessment of Performance/Progress</span>
            </v-tooltip>
          </v-layout>
        </v-flex>
        <!-- Measurable Data -->
        <v-flex xs12 sm6 md4 style="display: flex; align-items: center; margin-bottom: 10px;">
            <h4 style="margin-right: 10px;">Measurable Data</h4>
            <!-- dialog -->
            <div class="text-center">
            <v-btn outlined color="primary" small @click="measurableDialog = true">Open</v-btn>
            <v-dialog v-model="measurableDialog" width="600px">
                <v-card>
                  <v-card-text>
                  <h2 class="title-text">Measurable Data</h2>
                  <v-checkbox v-model="measurable1Checked">
                    <template v-slot:label>
                      <div>
                        <h4>Completed task
                          <input class="small-input" type="number" min="0" v-model="record.measurable[0].value1"/>
                          out of
                          <input class="small-input" type="number" min="0" v-model="record.measurable[0].value2"/> times</h4>
                      </div>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-model="measurable2Checked">
                    <template v-slot:label>
                      <div>
                        <h4>Completed task in
                          <input class="small-input" type="number" v-model="record.measurable[1].value1"/>
                          minutes
                        </h4>
                      </div>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-model="measurable3Checked">
                    <template v-slot:label>
                      <div>
                        <h4>Completed task with
                          <input class="small-input" type="number" v-model="record.measurable[2].value1"/>
                          % accuracy
                        </h4>
                      </div>
                    </template>
                  </v-checkbox>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" block @click="measurableDialog = false">Close</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
          </div>
        </v-flex>
        <!-- measurable mobile values -->
        <v-flex v-if="isMobile || isTablet" class="display-values" xs8 md4 style="display: flex; align-items: right;">
          <div v-if="record.measurable[0].value1 && record.measurable[0].value2" class="text-with-icon">
            <h5 class="text">
              Completed task {{ record.measurable[0].value1 }} out of {{ record.measurable[0].value2 }} times
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearMeasurable1Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="record.measurable[0].value1 && !record.measurable[0].value2" class="text-with-icon">
            <h5 class="text">
              Completed task {{ record.measurable[0].value1 }} times
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearMeasurable1Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="!record.measurable[0].value1 && record.measurable[0].value2" class="text-with-icon">
            <h5 class="text">
              Completed task {{ record.measurable[0].value2 }} times
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearMeasurable1Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="record.measurable[1].value1" class="text-with-icon">
            <h5 class="text">
              Completed task in {{ record.measurable[1].value1 }} minutes
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearMeasurable2Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="record.measurable[2].value1" class="text-with-icon">
            <h5 class="text">
              Completed task with {{ record.measurable[2].value1 }}% accuracy
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearMeasurable3Values()">
              mdi-close
            </v-icon>
          </div>
        </v-flex>
        <!-- Level of assistance -->
        <v-flex xs12 sm6 md4 style="display: flex; align-items: center; margin-bottom: 10px;">
          <h4 style="margin-right: 10px;">Level of Assistance</h4>
          <!-- dialog -->
          <div class="text-center">
            <v-btn outlined color="primary" small @click="assistanceDialog = true">Open</v-btn>
            <v-dialog v-model="assistanceDialog" width="600px">
                <v-card>
                  <v-card-text>
                  <h2 class="title-text">Level of Assistance</h2>
                  <v-checkbox v-model="assist1Checked">
                    <template v-slot:label>
                      <div>
                        <h4>Required assistance
                          <input class="small-input" type="number" v-model="record.assistance[0].value1"/>
                          out of
                          <input class="small-input" type="number" v-model="record.assistance[0].value2"/> times</h4>
                      </div>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-model="assist2Checked">
                    <template v-slot:label>
                      <div>
                        <h4>Required assistance for
                          <input class="small-input" type="number" v-model="record.assistance[1].value1"/>
                          minutes
                        </h4>
                      </div>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-model="assist3Checked">
                    <template v-slot:label>
                      <div>
                        <h4>Required assistance
                          <input class="small-input" type="number" v-model="record.assistance[2].value1"/>
                          % of the time
                        </h4>
                      </div>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-model="assist4Checked">
                    <template v-slot:label>
                      <div>
                        <h4>None</h4>
                      </div>
                    </template>
                  </v-checkbox>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" block @click="assistanceDialog = false">Close</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
          </div>
        </v-flex>
        <!-- level of assistance mobile values -->
        <v-flex v-if="isMobile || isTablet" class="display-values" xs8 md4 style="display: flex; align-items: right;">
          <div v-if="record.assistance[0].value1 && record.assistance[0].value2" class="text-with-icon">
            <h5 class="text">
              Required assistance {{ record.assistance[0].value1 }} out of {{ record.assistance[0].value2 }} times
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearAssistance1Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="record.assistance[0].value1 && !record.assistance[0].value2" class="text-with-icon">
            <h5 class="text">
              Required assistance {{ record.assistance[0].value1 }} times
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearAssistance1Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="!record.assistance[0].value1 && record.assistance[0].value2" class="text-with-icon">
            <h5 class="text">
              Required assistance {{ record.assistance[0].value2 }} times
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearAssistance1Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="record.assistance[1].value1" class="text-with-icon">
            <h5 class="text">
              Required assistance for {{ record.assistance[1].value1 }} minutes
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearAssistance2Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="record.assistance[2].value1" class="text-with-icon">
            <h5 class="text">
              Required assistance for {{ record.assistance[2].value1 }}% of the time
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearAssistance3Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="assist4Checked" class="text-with-icon">
            <h5 class="text">
              None
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearAssistance4Values()">
              mdi-close
            </v-icon>
          </div>
        </v-flex>
        <!-- Type of Assistance -->
        <v-flex xs12 sm6 md4 style="display: flex; align-items: center; margin-bottom: 10px;">
          <h4>Type of Assistance</h4>
          <div class="text-center">
            <v-btn outlined color="primary" small @click="typeDialog = true">Open</v-btn>
            <v-dialog v-model="typeDialog" width="600px">
                <v-card>
                  <v-card-text>
                  <h2 class="title-text">Type of Assistance</h2>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-checkbox
                        v-for="(item, index) in sessionAssistTypes"
                        :key="index"
                        v-model="checkedAssistTypes[index]"
                      >
                        <template v-slot:label>
                          <h4>{{ item.name }}</h4>
                          <v-text-field
                            style="padding-left: 10px; padding-top: 15px;"
                            v-if="item.name === 'Other'"
                            v-model="otherTypeValue"
                            placeholder="Enter other value"
                            @blur="handleOtherCheckboxChange(index)"
                          ></v-text-field>
                        </template>
                      </v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" block @click="typeDialog = false">Close</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
          </div>
        </v-flex>
        <!-- assistance type mobile values -->
      <v-flex v-if="isMobile || isTablet" class="display-values" xs8 md4 style="display: flex; align-items: right;">
        <div v-for="(item, index) in checkedTypeAssistTypes" :key="index">
          <div v-if="item.checked" class="text-with-icon">
            <h5 v-if="item.code !== 'OTHER'" class="text">{{ item.assistType }}</h5>
            <h5 v-if="item.code === 'OTHER'" class="text">Other: {{ item.assistType }}</h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearTypeValue(item.code)"
            >
              mdi-close
            </v-icon>
          </div>
        </div>
      </v-flex>
        <!-- measurable md-large screen values -->
        <v-flex v-if="!isMobile && !isTablet" class="display-values" xs4 md4 style="display: flex; align-items: right;">
          <div v-if="record.measurable[0].value1 && record.measurable[0].value2" class="text-with-icon">
            <h5 class="text">
              Completed task {{ record.measurable[0].value1 }} out of {{ record.measurable[0].value2 }} times
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearMeasurable1Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="record.measurable[0].value1 && !record.measurable[0].value2" class="text-with-icon">
            <h5 class="text">
              Completed task {{ record.measurable[0].value1 }} times
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearMeasurable1Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="!record.measurable[0].value1 && record.measurable[0].value2" class="text-with-icon">
            <h5 class="text">
              Completed task {{ record.measurable[0].value2 }} times
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearMeasurable1Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="record.measurable[1].value1" class="text-with-icon">
            <h5 class="text">
              Completed task in {{ record.measurable[1].value1 }} minutes
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearMeasurable2Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="record.measurable[2].value1" class="text-with-icon">
            <h5 class="text">
              Completed task with {{ record.measurable[2].value1 }}% accuracy
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearMeasurable3Values()">
              mdi-close
            </v-icon>
          </div>
        </v-flex>
        <!-- level of assistance values -->
        <v-flex v-if="!isMobile && !isTablet" class="display-values" xs4 md4 style="display: flex; align-items: right;">
          <div v-if="record.assistance[0].value1 && record.assistance[0].value2" class="text-with-icon">
            <h5 class="text">
              Required assistance {{ record.assistance[0].value1 }} out of {{ record.assistance[0].value2 }} times
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearAssistance1Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="record.assistance[0].value1 && !record.assistance[0].value2" class="text-with-icon">
            <h5 class="text">
              Required assistance {{ record.assistance[0].value1 }} times
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearAssistance1Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="!record.assistance[0].value1 && record.assistance[0].value2" class="text-with-icon">
            <h5 class="text">
              Required assistance {{ record.assistance[0].value2 }} times
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearAssistance1Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="record.assistance[1].value1" class="text-with-icon">
            <h5 class="text">
              Required assistance for {{ record.assistance[1].value1 }} minutes
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearAssistance2Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="record.assistance[2].value1" class="text-with-icon">
            <h5 class="text">
              Required assistance for {{ record.assistance[2].value1 }}% of the time
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearAssistance3Values()">
              mdi-close
            </v-icon>
          </div>
          <div v-if="assist4Checked" class="text-with-icon">
            <h5 class="text">
              None
            </h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearAssistance4Values()">
              mdi-close
            </v-icon>
          </div>
        </v-flex>
      <!-- assistance type mg-lg screen values -->
      <v-flex v-if="!isMobile && !isTablet" class="display-values" xs4 md4 style="display: flex; align-items: right;">
        <div v-for="(item, index) in checkedTypeAssistTypes" :key="index">
          <div v-if="item.checked" class="text-with-icon">
            <h5 v-if="item.code !== 'OTHER'" class="text">{{ item.assistType }}</h5>
            <h5 v-if="item.code === 'OTHER'" class="text">Other: {{ item.assistType }}</h5>
            <v-icon
              x-small
              id="clearIcon"
              class="icon"
              @click="clearTypeValue(item.code)"
            >
              mdi-close
            </v-icon>
          </div>
        </div>
      </v-flex>
    </v-layout>
    </v-form>
  </template>
<script>

import Swal from 'sweetalert2';

/* eslint-disable */
  export default {
    name: 'ProgressRepeatable',
    props: ['student', 'index', 'record', 'showTooltip', 'v', 'sessionAssistTypes', 'action'],
    data() {
      return {
        measurableDialog: false,
        assistanceDialog: false,
        typeDialog: false,
        measurable1Checked: false,
        measurable2Checked: false,
        measurable3Checked: false,
        assist1Checked: false,
        assist2Checked: false,
        assist3Checked: false,
        assist4Checked: false,
        type1Checked: false,
        type2Checked: false,
        type3Checked: false,
        type4Checked: false,
        checkedAssistTypes: [],
        otherTypeValue: ''
      };
    },
    created() {
        // Initialize checkedAssistTypes with the initial values from record.type
        this.checkedAssistTypes = this.record.type.map(item => item.checked);
      },
    mounted() {
      if ((this.action == "edit" || this.action == "copy")) {
        for (let i = 0; i < this.record.type.length; i++) {
          if (this.record.type[i].code === "OTHER") {
            this.otherTypeValue = this.record.type[i].assistType;
            break; // Exit the loop once we find the first 'OTHER' code
          }
        }
      }

      this.record.assistance.forEach((progress) => {
        if(this.action === 'copy' || this.action === 'edit') {
          if (progress.type === "NONE" && progress.value1) {
            this.assist4Checked = true;
          }
        }
      });
    },
    computed: {
      isMobile() {
        return this.$mq === 'mobile';
      },
      isTablet() {
        return this.$mq === 'tablet';
      },
      isCheckedAssistType() {
        const isChecked = {};
        this.sessionAssistTypes.forEach((item) => {
          isChecked[item.name] = this.record.type[item.name] === true;
        });
        return isChecked;
      },
      checkedTypeAssistTypes() {
        return this.record.type.filter((item) => item.checked);
      },
      assistTypeMapping() {
        const mapping = {};
        for (const item of this.sessionAssistTypes) {
          mapping[item.code] = item;
        }
        return mapping;
      },
      checkedAssistTypes() {
        return this.checkedAssistTypes;
      },
      taskErrors() {
        const errors = [];
        const task = this.v.ptSessionProgresses;
        if (!task || !task.$dirty) return errors;
        if (task.required && !this.record.task) {
          errors.push('Task is required.');
        }
        return errors;
      }
    },
    methods: {
      emitRemoveRecordClicked() {
        Swal.fire({
          text: 'Are you sure you want to delete this record?',
          confirmButtonText: 'Delete',
          showCancelButton: true,
          customClass: {
            popup: 'popup-class',
            content: 'content-class',
            confirmButton: 'confirm-button-class delete'
          }
        }).then((response) => {
          if (response && response.value) this.$emit('delete:record', { index: this.index });
        });
      },
      clearMeasurable1Values() {
        this.record.measurable[0].value1 = '';
        this.record.measurable[0].value2 = '';
        this.measurable1Checked = false;
      },
      clearMeasurable2Values() {
        this.record.measurable[1].value1 = '';
        this.measurable2Checked = false;
      },
      clearMeasurable3Values() {
        this.record.measurable[2].value1 = '';
        this.measurable3Checked = false;
      },
      clearAssistance1Values() {
        this.record.assistance[0].value1 = '';
        this.record.assistance[0].value2 = '';
        this.assist1Checked = false;
      },
      clearAssistance2Values() {
        this.record.assistance[1].value1 = '';
        this.assist2Checked = false;
      },
      clearAssistance3Values() {
        this.record.assistance[2].value1 = '';
        this.assist3Checked = false;
      },
      clearAssistance4Values() {
        this.record.assistance[3].value1 = false;
        this.assist4Checked = false;
      },
      clearTypeValue(code) {
        const item = this.record.type.find((item) => item.code === code);
        if (item) {
          item.checked = false;
          if (code === 'OTHER') {
            item.assistType = '';
          }
        }
      },
      handleTextTrimmingRequired(field, value) {
        this.v.ptSessionProgresses.$touch();
        if (value !== null && value !== undefined) {
          const trimmed = this.record.task.trim();
          this.record.task = trimmed;
        }
      },
      handleOtherCheckboxChange(index) {
        if (this.sessionAssistTypes[index].name === 'Other' && this.otherTypeValue != '') {
          // Set the assistType to the value in otherTypeValue when "Other" is checked
          this.record.type[index].assistType = this.otherTypeValue;
        }
      }
    },
    watch: {
      record: {
        handler() {
          if (this.assist4Checked) {
            this.record.assistance[3].value1 = "none";
            this.record.assistance[3].type = "NONE";
          }
          else {
            this.record.assistance[3].value1 = false;
          }
          // clear out negative values
          if (this.record.measurable[0].value1 < 0) this.record.measurable[0].value1 = 0;
          if (this.record.measurable[0].value1 < 0) this.record.measurable[0].value2 = 0;
          if (this.record.measurable[1].value1 < 0) this.record.measurable[1].value1 = 0;
          if (this.record.measurable[2].value1 < 0) this.record.measurable[2].value1 = 0;

          if (this.record.assistance[0].value1 < 0) this.record.assistance[0].value1 = 0;
          if (this.record.assistance[0].value2 < 0) this.record.assistance[0].value2 = 0;
          if (this.record.assistance[1].value1 < 0) this.record.assistance[1].value1 = 0;
          if (this.record.assistance[2].value1 < 0) this.record.assistance[2].value1 = 0;
        },
        deep: true
      },
      checkedAssistTypes: {
        handler(newCheckedState) {
          // Synchronize changes to record.type
          this.record.type.forEach((item, index) => {
            item.checked = newCheckedState[index];
            if (item.code === 'OTHER' && item.checked && this.otherTypeValue != '') {
              // Set the assistType to the value in otherTypeValue when "Other" is checked
              item.assistType = this.otherTypeValue;
            }
          });
        },
        deep: true,
      },
      assist4Checked: {
        handler() {
          if (this.assist4Checked) {
            this.record.assistance[3].value1 = "none";
            this.record.assistance[3].type = "NONE";
          }
          else {
            this.record.assistance[3].value1 = false;
          }
        },
        deep: true
      }
    }
  };
</script>
  <style lang="scss" scoped>
    .progress-container {
      margin: 20px 0 !important;
      padding: 20px 15px 0 15px;
      background-color: #fff;
      box-shadow: 0 0 8px rgba(0,0,0,0.2);
      border-radius: 10px;
    }
    .small-input {
      width: 50px;
      border: none;
      border-bottom: 1px solid #06022f; /* Change the color as needed */
      outline: none;
    }
    .title-text {
      color: #2c3e50;
    }
    #deleteIcon:hover {
      color: var(--v-error-base);
    }
    .text-with-icon {
      display: flex;
      align-items: center;
    }
    .text {
      margin-right: 10px; // Adjust this value as needed
    }
    .icon {
      cursor: pointer;
    }
    .display-values {
      display: flex;
      align-items: right;
      flex-direction: column;
    }
    /deep/ .objective-select {
      .v-select__selections {
        max-width: 96%;
        .objective-chip {
          max-width: 98%;
          .v-chip__content {
            width: 100%;
            span {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  </style>



// WEBPACK FOOTER //
// src/components/service-log/form/progress-repeatable.vue